<script lang="ts">
  export let width: number = 130;
  export let height: number = 80;
  export let className: string = "";
  // Font Awesome solid icons preferred
  export let mountainClass: string = "fa-solid fa-mountain";
  export let wheatClass: string = "fa-solid fa-wheat-awn";
  export let mapleClass: string = "fa-solid fa-leaf-maple";
  export let treesClass: string = "fa-solid fa-trees";

  export let distanceText: string;

</script>

<div class="relative" style={`width:${width}px;height:${height}px;`}>
  <svg
    {width}
    {height}
    viewBox="0 0 130 80"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Cross Canada passport stamp"
    class={className}
  >
    <title>Cross Canada Passport Stamp</title>

    <!-- Canoe plaque outline (flat top/bottom with upward-curved ends) -->
    <!-- Outer canoe shape -->
    <path
      d="M 20 62
         L 110 62
         Q 130 62 122 40
         Q 112 44 100 44
         L 30 44
         Q 18 44 8 40
         Q 0 62 20 62
         Z"
      fill="none"
      stroke="#000"
      stroke-width="2.5"
    />

    <!-- Inner rule (slightly inset) -->
    <!-- <path
      d="M 16 57
         L 114 57
         L 114 56
         Q 109 51.5 106 50
         L 24 50
         Q 20.5 51.5 16 56
         Z"
      fill="none"
      stroke="#000"
      stroke-width="0.9"
      opacity="0.95"
    /> -->

    <!-- Top rim beads (rivet pins) along the flat section of the rim -->
    <path d="M 24 48 L 108 48" stroke="#000" stroke-width="1" stroke-linecap="round" stroke-dasharray="0.4 4" opacity="0.85" />

    <!-- Title texts above the top flat of the canoe -->
    <g transform="translate(65,0)">
      <!-- Distance above the title -->
      <text x="0" y="30" fill="#000" font-size="8" font-weight="700" text-anchor="middle" style="letter-spacing:1px;">{distanceText}</text>
      <!-- CROSS CANADA just above the rim -->
      <text x="0" y="39" fill="#000" font-size="11" font-weight="900" text-anchor="middle" style="letter-spacing:2px;paint-order:stroke fill;stroke:#000;stroke-width:0.7;">CROSS CANADA</text>
    </g>

    <!-- Subtle water band inside canoe (black-only opacity) -->
    <!-- <path
      d="M 18 54 C 28 52, 36 55, 46 53 C 56 51, 68 55, 80 52 C 92 49, 102 54, 112 52 L 112 58 L 18 58 Z"
      fill="#000"
      opacity="0.08"
    /> -->

    <!-- Meandering route inside canoe -->
    <!-- <path d="M 24 53 C 36 51, 50 54, 64 52 C 78 50, 96 54, 108 52" fill="none" stroke="#000" stroke-width="1.2" stroke-dasharray="3 2" opacity="0.85" /> -->
    <!-- Small chevrons along the route -->
    <!-- <path d="M 52 51 L 54 53 L 52 55" fill="none" stroke="#000" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M 86 50 L 88 52 L 86 54" fill="none" stroke="#000" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" /> -->
  </svg>

  <!-- Font Awesome overlays inside the canoe, following the curve -->
  <!-- Mountain (west) -->
  <div class="absolute" style="top:54px;left:28px;transform:translate(-50%, -50%) rotate(8deg);color:#000;">
    <i class={mountainClass} style="font-size:16px;line-height:1;color:#000;opacity:0.95;"></i>
  </div>
  <!-- Wheat (prairies) -->
  <div class="absolute" style="top:54px;left:54px;transform:translate(-50%, -50%) rotate(4deg);color:#000;">
    <i class={wheatClass} style="font-size:16px;line-height:1;color:#000;opacity:0.95;"></i>
  </div>
  <!-- Maple leaf (central/east) -->
  <div class="absolute" style="top:54px;left:78px;transform:translate(-50%, -50%) rotate(-2deg);color:#000;">
    <i class={mapleClass} style="font-size:16px;line-height:1;color:#000;opacity:0.95;"></i>
  </div>
  <!-- Trees (east coast) -->
  <div class="absolute" style="top:54px;left:104px;transform:translate(-50%, -50%) rotate(-6deg);color:#000;">
    <i class={treesClass} style="font-size:16px;line-height:1;color:#000;opacity:0.95;"></i>
  </div>
</div>
